(function () {
  var REBUY_PROGRESS_SELECTORS = [
    '.rebuy-cart__progress-bar-container',
    '.rebuy-cart__flyout-shipping-bar',
    '.cart-gam',
  ];

  var CART_PAGE_SELECTORS = ['[data-free-shipping]'];

  function getMembershipProductId() {
    var id = window.theme && window.theme.settings && window.theme.settings.rebuyMembershipProductId;
    return String(id || '7528500002910').trim();
  }

  function getCartItems(source) {
    if (!source) {
      source = window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.cart;
    }
    if (!source) return [];

    if (typeof source.items === 'function') {
      return source.items() || [];
    }

    if (Array.isArray(source.items)) {
      return source.items;
    }

    if (source.cart) {
      return getCartItems(source.cart);
    }

    return [];
  }

  function itemMatchesMembership(item, membershipId) {
    var productId = String(item.product_id || (item.product && item.product.id) || '');
    return productId === membershipId;
  }

  function isMembershipOnlyCart(source) {
    var items = getCartItems(source);
    var membershipId = getMembershipProductId();

    if (!items.length) return false;

    return items.every(function (item) {
      return itemMatchesMembership(item, membershipId);
    });
  }

  function setElementHidden(el, hide) {
    if (!el) return;
    if (hide) {
      el.style.setProperty('display', 'none', 'important');
    } else {
      el.style.removeProperty('display');
    }
  }

  function setProgressElementsHidden(hide) {
    document.body.classList.toggle('rebuy-membership-only-cart', hide);

    REBUY_PROGRESS_SELECTORS.forEach(function (selector) {
      document.querySelectorAll('#rebuy-cart ' + selector).forEach(function (el) {
        setElementHidden(el, hide);
      });
    });

    CART_PAGE_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        setElementHidden(el, hide);
        var cartBlock = el.closest('.cart-block');
        if (cartBlock) setElementHidden(cartBlock, hide);
      });
    });
  }

  function toggleMembershipProgressBar(source) {
    setProgressElementsHidden(isMembershipOnlyCart(source));
  }

  function syncFromShopifyCart() {
    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        setProgressElementsHidden(isMembershipOnlyCart(cart));
      })
      .catch(function () {});
  }

  function scheduleToggle(source) {
    toggleMembershipProgressBar(source);
    requestAnimationFrame(function () {
      toggleMembershipProgressBar(source);
    });
    setTimeout(function () {
      toggleMembershipProgressBar(source);
      syncFromShopifyCart();
    }, 100);
  }

  document.addEventListener('rebuy:cart.change', function (event) {
    scheduleToggle(event.detail && event.detail.cart);
  });

  document.addEventListener('rebuy:smartcart.ready', function () {
    scheduleToggle();
  });

  document.addEventListener('rebuy:smartcart.show', function () {
    scheduleToggle();
  });

  document.addEventListener('theme:cart:change', function () {
    syncFromShopifyCart();
  });

  document.addEventListener('theme:cart:update', function () {
    syncFromShopifyCart();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromShopifyCart);
  } else {
    syncFromShopifyCart();
  }
})();
